import enBlogPosts from "./blogPosts.json";
import enBghUrteile from "./bghUrteile.json";
import enCalculator from "./calculator.json";
import enCommon from "./common.json";
import enDialogs from "./dialogs.json";
import enExpertise from "./expertise.json";
import enExpertiseSolutions from "./expertiseSolutions.json";
import enFaqs from "./faqs.json";
import enFooter from "./footer.json";
import enHome from "./home.json";
import enJudgmentsLanding from "./judgmentsLanding.json";
import enLandingpages from "./landingpages.json";
import enNav from "./nav.json";
import enReferences from "./references.json";
import enSolvingTax from "./solvingTax.json";
import enTeam from "./team.json";

/** Merged onto `deCatalog` via `mergeDeep` in `buildCatalog` (no `expertiseCity` — inherits DE). */
export const enMessageOverlay = {
  nav: enNav,
  footer: enFooter,
  home: enHome,
  common: enCommon,
  dialogs: enDialogs,
  expertise: enExpertise,
  blogPosts: enBlogPosts,
  expertiseSolutions: enExpertiseSolutions,
  team: enTeam,
  references: enReferences,
  landingpages: enLandingpages,
  solvingTax: enSolvingTax,
  faqs: enFaqs,
  calculator: enCalculator,
  judgmentsLanding: enJudgmentsLanding,
  bghUrteile: enBghUrteile,
} as const;
